<template>
  <DeleteConfirmationModal
    :isLoading="isLoading"
    :title="$t('teams.delete_title')"
    :text="$t('teams.delete_confirmation')"
    :show="show"
    @cancel="$emit('cancel')"
    @delete="deleteTeam"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import mixin from '@/mixins/mixin.vue'
import DeleteConfirmationModal from '@/components/Modals/DeleteConfirmationModal.vue'

export default {
  mixins: [mixin],

  components: {
    DeleteConfirmationModal,
  },

  props: {
    show: Boolean,
    teamId: String,
  },

  data() {
    return {
      isLoading: false,
    }
  },

  computed: {
    ...mapGetters(['organizationId']),
  },

  methods: {
    async deleteTeam() {
      try {
        this.isLoading = true
        await api.teams.delete(this.organizationId, this.teamId)
        this.$emit('deleted')
      } catch (error) {
        this.handleRequestError(error)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
